import { useTranslation } from '@/hooks/useTranslation';
import { useState } from 'react';
import { useReveal } from '@/hooks/useReveal';
import { Lock } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

const NewsletterSection = () => {
  const { t, language } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState('');
  useReveal();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await supabase.from('newsletter_subscribers').insert({
        email,
        language,
      });
      // Send branded confirmation email
      await supabase.functions.invoke('confirm-newsletter', {
        body: { email, language },
      });
    } catch {}
    setSubmitted(true);
  };

  return (
    <section id="newsletter">
      <div className="nl-wrap rev">
        <div className="section-tag">{t.newsletter.tag}</div>
        <h2 className="section-h" style={{ whiteSpace: 'pre-line' }}>{t.newsletter.title}</h2>
        <p className="section-sub">{t.newsletter.subtitle}</p>

        {!submitted ? (
          <>
            <form className="nl-form" onSubmit={handleSubmit}>
              <input type="email" placeholder={t.newsletter.placeholder} required value={email} onChange={e => setEmail(e.target.value)} />
              <button type="submit">{t.newsletter.cta}</button>
            </form>
            <p className="nl-note">
              <Lock size={12} /> {t.newsletter.note}
            </p>
          </>
        ) : (
          <p style={{ color: 'var(--blue)', fontWeight: 700, fontSize: '.95rem', marginTop: '20px' }}>
            {t.newsletter.success}
          </p>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;
